import { api , base_url_v1 , base_url_v2 } from "./api";

export const LoginApi = async (formRef:any) => {
    const postData = JSON.stringify({
        IMEI:"a" ,
        username:formRef.current['email'].value ,
        password:formRef.current['password'].value ,
    })
    const data = await api({ url: `${base_url_v1}login`, method: "POST" , body:postData })
    return { data };
}

export const RegisterApi = async (formRef:any) => {
    const postData = JSON.stringify({
        IMEI:"a" ,
        name:formRef.current['name'].value ,
        username:formRef.current['email'].value ,
        mobile:formRef.current['mobile'].value ,
        password:formRef.current['password'].value ,
        password_confirmation:formRef.current['password2'].value ,
    })
    const data = await api({ url: `${base_url_v2}company/register`, method: "POST" , body:postData })
    return { data };
}

export const ForgetApi = async (formRef:any) => {
    const postData = JSON.stringify({
        email:formRef.current['email'].value ,
    })
    const data = await api({ url: `${base_url_v2}company/forget-password`, method: "POST" , body:postData })
    return { data };
}